import { render } from "./wallControl.vue?vue&type=template&id=236f809b"
import script from "./wallControl.vue?vue&type=script&lang=js"
export * from "./wallControl.vue?vue&type=script&lang=js"

import "./wallControl.vue?vue&type=style&index=0&id=236f809b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__